import { FormBuilder } from "@/components/form-builder"
import { HeaderForm } from "@/components/header-form"
import { SimpleAccordion } from "@/components/ui/simple-accordion"
import { FormActions } from "../components/person-steps/form-actions"
import { usePersonPJAdd } from "../hooks/use-person-pj-add"

interface PersonPJAddViewProps {
  onContinue: () => void
  onBack: () => void
}

export function PersonPJAddView({ onContinue, onBack }: PersonPJAddViewProps) {
  const { form, isPending, onFormSubmit, companyFields, bankFields } =
    usePersonPJAdd({ onSuccess: onContinue })

  const accordionItems = [
    {
      id: "company",
      title: <HeaderForm title="DADOS DA EMPRESA" />,
      content: (
        <FormBuilder
          fields={companyFields}
          layout={{ columns: 2, gap: "md" }}
          formInstance={form}
          onSubmit={async () => undefined}
          showSave={false}
        />
      ),
    },
    {
      id: "bank",
      title: <HeaderForm title="DADOS BANCÁRIOS" />,
      content: (
        <FormBuilder
          fields={bankFields}
          layout={{ columns: 2, gap: "md" }}
          formInstance={form}
          onSubmit={async () => undefined}
          showSave={false}
        />
      ),
    },
  ]

  return (
    <div className="space-y-8">
      <SimpleAccordion
        className="bg-darkblue rounded-lg p-8"
        itemClassName="border-none"
        items={accordionItems}
      />

      <FormActions
        isPending={isPending}
        onBack={onBack}
        onSubmit={form.handleSubmit(onFormSubmit, (errors) => console.log("Validation errors:", errors))}
      />
    </div>
  )
}
